<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconArrowCornerDown_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M1.875 1c.483 0 .875.392.875.875v5.011c0 .508.215 1.008.62 1.386a2.3 2.3 0 0 0 1.568.603h7.075L9.13 5.994a.875.875 0 0 1 1.238-1.238l4.375 4.375a.875.875 0 0 1 0 1.238l-4.375 4.375a.875.875 0 0 1-1.238-1.238l2.882-2.881H4.938c-1.027 0-2.021-.38-2.764-1.075A3.65 3.65 0 0 1 1 6.886V1.875C1 1.392 1.392 1 1.875 1"
        clip-rule="evenodd"
    />
</svg>
